import { Num, removeComma } from 'utils'

export const paymentFromEscrowOvKey = (monthIndex: number) => `Loan.PaymentFromEscrowOV${monthIndex}`

export const hasPaymentFromEscrowOverride = (data: Record<string, any>, monthIndex: number): boolean => {
  const ov = data[paymentFromEscrowOvKey(monthIndex)]
  return ov !== undefined && ov !== null && String(ov).trim() !== ''
}

export const getEffectivePaymentFromEscrow = (
  data: Record<string, any>,
  monthIndex: number,
  calculated: number,
): number => {
  if (!hasPaymentFromEscrowOverride(data, monthIndex)) return calculated
  return Num(removeComma(data[paymentFromEscrowOvKey(monthIndex)]))
}

export const applyPaymentFromEscrowOverrides = (data: Record<string, any>, calculated: number[]): number[] =>
  calculated.map((value, i) => getEffectivePaymentFromEscrow(data, i, value))
